// The beta controls (CHT-780): two operator switches that cut AI customer features without a deploy, and the one rule that decides
// whether the AI may serve a customer. Pure: no clock, no database, no provider. Docs: docs/operations/beta/control-inventory.md.
//
// Both switches are "engaged = risk reduced". No row in the database means NOT engaged, so a new environment behaves as before.
//   AI_PAUSE     engaged: no AI reply, no AI run, no AI tool write. Customer messages go to a person (human-only mode).
//   COHORT_GATE  engaged: only the customers of the beta cohort get AI features. Everybody else is in human-only mode.
// The environment setting `LAFAYETTE_MESSAGING_AI_REPLIES=off` always wins. An operator control can only take AI away, never give it back.
export const operatorControlKeys = Object.freeze(["AI_PAUSE", "COHORT_GATE"]);
/** Why an operator changed a control. A closed code, never text. */
export const operatorControlReasons = Object.freeze([
    "INCIDENT",
    "PROVIDER_OUTAGE",
    "COST",
    "MAINTENANCE",
    "BETA_SCOPE",
    "PROOF",
]);
/** The id of a beta cohort: lowercase letters, digits and hyphens. An opaque label, never a name of a person. */
export const BETA_COHORT_ID_PATTERN = /^[a-z0-9][a-z0-9-]{0,39}$/;
/** The reasons the AI may not serve a customer, in the order the rule checks them. */
export const aiUnavailableReasons = Object.freeze([
    "REPLIES_OFF",
    "AI_PAUSED",
    "NOT_IN_COHORT",
    "CONTROL_UNREADABLE",
    // Never returned by `decideAiAvailability`: the reply executor finds the agent runtime switched off at the claim (LAFAYETTE_AGENT_RUNTIME=off).
    "RUNTIME_OFF",
]);
/**
 * Whether the AI may serve this customer now. A control that cannot be read, and a cohort source that does not answer, FAIL CLOSED:
 * the customer is served by a person. The first refusal is returned.
 */
export function decideAiAvailability(facts) {
    const no = (reason) => ({ available: false, reason });
    if (facts.envReplies !== "on")
        return no("REPLIES_OFF");
    if (facts.aiPause === "UNREADABLE")
        return no("CONTROL_UNREADABLE");
    if (facts.aiPause === "ENGAGED")
        return no("AI_PAUSED");
    if (facts.cohortGate === "UNREADABLE")
        return no("CONTROL_UNREADABLE");
    if (facts.customerErased)
        return no("NOT_IN_COHORT");
    if (facts.cohortGate === "ENFORCED") {
        if (facts.cohortMember === "UNKNOWN")
            return no("CONTROL_UNREADABLE");
        if (facts.cohortMember !== "MEMBER")
            return no("NOT_IN_COHORT");
    }
    return { available: true };
}
